import { render } from "./ManikinSelector.vue?vue&type=template&id=4cb86b41"
import script from "./ManikinSelector.vue?vue&type=script&lang=js"
export * from "./ManikinSelector.vue?vue&type=script&lang=js"

import "./ManikinSelector.vue?vue&type=style&index=0&id=4cb86b41&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__